


import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const BackendURL = `${config.backendUrl}/managerProjectRequested`;

export const updateProjectSLA = createAsyncThunk(
  "projectSLA/updateById",
  async ({ projectId, followupDate }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.put(
        `${BackendURL}/projects/${projectId}/sla`,
        { followupDate }
      );
      return data.project;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.error || "Failed to update SLA by projectId"
      );
    }
  }
);

// REFACTORED: Now uses projectId instead of projectName to support duplicate project names
// UNDO: Change back to projectName parameter and URL if reverting
export const updateProjectSLAByName = createAsyncThunk(
  "projectSLA/updateByName",
  async ({ projectId, projectDueDate }, { rejectWithValue }) => {
    try {
      // Use projectId instead of projectName in URL
      const { data } = await axiosInstance.put(
        `${BackendURL}/projects/${projectId}/sla`,
        { projectDueDate }
      );
      return data.project;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.error || "Failed to update SLA by projectId"
      );
    }
  }
);

const projectSLASlice = createSlice({
  name: "projectSLA",
  initialState: {
    project: null,
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetSLAState: (state) => {
      state.project = null;
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(updateProjectSLA.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateProjectSLA.fulfilled, (state, action) => {
        state.loading = false;
        state.project = action.payload;
        state.success = true;
      })
      .addCase(updateProjectSLA.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });

    builder
      .addCase(updateProjectSLAByName.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateProjectSLAByName.fulfilled, (state, action) => {
        state.loading = false;
        state.project = action.payload;
        state.success = true;
      })
      .addCase(updateProjectSLAByName.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export const { resetSLAState } = projectSLASlice.actions;

export default projectSLASlice.reducer;
